export default __webpack_public_path__ + "static/media/personal-tracking-system.e64c4433.jpg";